/** SEO defaults when CMS is unavailable (e.g. meta tags). */
export const HERO_HEADING_FALLBACK =
  "Custom apps for businesses that have outgrown their systems";

/** Set true to show homepage quote block, /testimonials page, and footer link. */
export const SHOW_TESTIMONIALS = false;

/** Set true to show homepage "What gets built" services table and footer #what link. */
export const SHOW_SERVICES_SECTION = false;
